var map = {
	"./sticker-1.png": 68,
	"./sticker-10.png": 69,
	"./sticker-11.png": 70,
	"./sticker-12.png": 71,
	"./sticker-13.png": 72,
	"./sticker-14.png": 73,
	"./sticker-15.png": 74,
	"./sticker-16.png": 75,
	"./sticker-17.png": 76,
	"./sticker-2.png": 77,
	"./sticker-3.png": 78,
	"./sticker-4.png": 79,
	"./sticker-5.png": 80,
	"./sticker-6.png": 81,
	"./sticker-7.png": 82,
	"./sticker-8.png": 83,
	"./sticker-9.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;